import React, { useCallback, useEffect } from "react";
import DataGrid, { Column, Editing, Paging } from "devextreme-react/data-grid";

import { useDispatch, useSelector } from "react-redux";
import {
  postResource,
  getResourceAPI,
  updateResource,
  deleteResource,
  getResourceStatus,
} from "../../redux/slices/resourceSlice.js";
import { handleNotificationMessage } from "../../utils/notifications.js";
import { DateBox } from "devextreme-react";
import { fromCustomDate } from "../../utils/date.js";
import { getUserId } from "../../redux/slices/userSlice.js";
import useResources from "../../hooks/useResources";
import Loader from "./Loader.jsx";

const GenericDataGrid = ({
  resourceName = "",
  reduxName = "",
  columns = [],
  query,
  id,
}) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => getUserId(state));

  const { [reduxName]: dataSource } = useResources();

  const status = useSelector((status) =>
    getResourceStatus(status, `${resourceName}Status`)
  );

  useEffect(() => {
    status === "idle" &&
      dispatch(getResourceAPI({ path: resourceName, query }));
  }, [dispatch, status, resourceName, query]);

  const onInitNewRow = useCallback(
    ({ data }) => {
      //TODO : get name from token
      data.user_id = userId;
    },
    [userId]
  );

  const onSaving = useCallback(
    (e) => {
      e.changes.forEach((change) => {
        switch (change.type) {
          case "insert":
            dispatch(
              postResource({
                path: `${resourceName}`,
                data: change.data,
              })
            ).then(({ payload }) => {
              e.cancel = true;
              e.component.cancelEditData();

              const { path, error, data } = payload;

              handleNotificationMessage(path, data?.id, error, change.type);
            });
            return;
          case "update":
            dispatch(
              updateResource({
                path: resourceName,
                id: change.key.id || change.key.stage,
                data: change.data,
              })
            ).then(({ payload }) => {
              e.cancel = true;
              e.component.cancelEditData();

              const { path, id, error } = payload;

              handleNotificationMessage(path, id, error, change.type);
            });
            return;
          case "remove":
            dispatch(
              deleteResource({ path: resourceName, id: change.key.id })
            ).then(({ payload }) => {
              e.cancel = true;
              e.component.cancelEditData();

              const { path, id, error } = payload;

              handleNotificationMessage(path, id, error, change.type);
            });
            return;
          default:
            return;
        }
      });

      e.cancel = true;
    },
    [dispatch, resourceName]
  );

  const makeCellUpperCase = useCallback((cellInfo) => {
    if (cellInfo.value) return cellInfo.value.toUpperCase();

    return "";
  }, []);

  return (
    <React.Fragment>
      {status === "pending" ? (
        <Loader style={{ marginLeft: "-10%", marginTop: "-10%" }} />
      ) : (
        <DataGrid
          style={{ marginBottom: "16px" }}
          id="gridContainer"
          rowAlternationEnabled={true}
          dataSource={dataSource || []}
          allowColumnReordering={true}
          showBorders={true}
          onSaving={onSaving}
          onInitNewRow={onInitNewRow}
        >
          <Paging enabled={true} />
          <Editing
            mode="batch"
            allowUpdating={true}
            allowAdding={true}
            allowDeleting={true}
            allowSorting={false}
          />
          {columns.map((column) =>
            column.type === "date" ? (
              <Column
                key={column.dataField}
                dataField={column.dataField}
                caption={column.caption}
                calculateCellValue={fromCustomDate}
                width={column.width}
                allowEditing={column.allowEditing}
                allowSorting={false}
              >
                <DateBox displayFormat="d/M/yyyy" />
              </Column>
            ) : (
              <Column
                key={column.dataField}
                cellRender={column.cellRender}
                // customizeText={makeCellUpperCase}
                dataField={column.dataField}
                caption={column.caption}
                width={column.width}
              />
            )
          )}
        </DataGrid>
      )}
    </React.Fragment>
  );
};
export default GenericDataGrid;
